import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'my-app';
 
  showNavigation = true;

  constructor(private router: Router) {
    // Memantau perubahan route
    this.router.events.subscribe((event: any) => {
      if (event.url) {
        // Sembunyikan navigasi jika di halaman /admin atau route anaknya
        this.showNavigation = !event.url.startsWith('/l_admin');
      }
    });
  }
}
